// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__PJgC+","nav__link":"Navigation_nav__link__euHWb","vertNav":"Navigation_vertNav__REpdg"};